import { toRefs, usePreferredLanguages, useStorage } from "@vueuse/core";
import { computed } from "vue-demi";

const PreferredLanguages = usePreferredLanguages();

const UIStorage = useStorage("ux-state", {
  locale: PreferredLanguages.value[0].split("-")[0],
  darkMode: false
});

export function useUXState() {
  return {
    ...toRefs(UIStorage),
    shortLocale: computed(() => UIStorage.value.locale.split("_")[0])
  };
}
